import { fetchFactory, urlUtils } from 'isotope-client'

/**
 * SyntheseOnglet
 */

export type SyntheseDatasPlanificationVsCharge = {
	dateDebut: string,
	chargeTravail: number
	capaciteTravail: number
	capaciteTravailRessource: number
	tempsTravail: number
	tempsTravailTache: number
}

export type SyntheseDatasStats = {
	capaciteTotale: number
	chargeTotale: number
	ressourcesDispo: number
	ressourcesPlanifiees: number
	tachesPrevues: number
	tachesPlanifieesValeur: number
	tachesPlanifieesPourcentage: number
}

export type SyntheseDatas = {
	semainesNonInitialisees: string[]
	stats: SyntheseDatasStats,
	planificationVsCharge: SyntheseDatasPlanificationVsCharge[]
}
export const getSyntheseResultatDatas = (isDebug: boolean) => fetchFactory<SyntheseDatas>(urlUtils.buildUrlWithParams(`/solution-taches/synthese`, { isDebug }))

export enum FAMILLE_TACHE {
	SOINS_PROTECTION,
	PREP_PLANCHE,
	DES,
	AUTRES,
	RECOLTE,
	SEMIS,
	IMPLANTATION
}

export type TachesParFamilleDetail = {
	dateDebut: string,
	repartition: { [key in FAMILLE_TACHE]: number }
	repartitionTache: { [key in FAMILLE_TACHE]: number }
}

export type TachesReportAnticipationDetail = {
	dateDebut: string
	moinsDeux: number
	moinsUn: number
	zero: number
	plusUn: number
	plusDeux: number
	plusTrois: number
	plusQuatreOuPlus: number
	moinsDeuxNbTaches: number
	moinsUnNbTaches: number
	zeroNbTaches: number
	plusUnNbTaches: number
	plusDeuxNbTaches: number
	plusTroisNbTaches: number
	plusQuatreOuPlusNbTaches: number
}

export type SyntheseDetailDatas = {
	tachesReportAnticipation: TachesReportAnticipationDetail[],
	tachesParFamille: TachesParFamilleDetail[]
}
export const getSyntheseResultatDetailDatas = (tachesPlanifiees: boolean) => fetchFactory<SyntheseDetailDatas>(urlUtils.buildUrlWithParams('/solution-taches/synthese/detail', { tachesPlanifiees }))
